import type { SVGProps } from "react";
export function EyeOff(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      data-slot="icon"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="m1.34087 1.64644c.19526-.19526.51184-.19526.7071 0l2.11577 2.11577c1.04251-.5913 2.24793-.92888 3.53098-.92888 3.20978 0 5.92538 2.10971 6.83848 5.01687.0307.09753.0307.20213 0 .29966-.4441 1.41394-1.3139 2.63814-2.4587 3.52314l1.9735 1.9735c.1953.1952.1953.5118 0 .707-.1953.1953-.5119.1953-.7071 0l-12.00003-11.99995c-.19527-.19526-.19527-.51185 0-.70711zm3.56104 2.85395 1.41387 1.41386c.39514-.26159.86934-.41425 1.37861-.41425 1.38073 0 2.50001 1.11928 2.50001 2.5 0 .50933-.1527.98353-.41421 1.37866l1.58051 1.58054c.9952-.7369 1.7604-1.76594 2.1693-2.9592-.8308-2.42459-3.1302-4.16667-5.83528-4.16667-1.00593 0-1.95465.24051-2.79281.66706zm4.14641 4.14641c.09373-.1958.14607-.41507.14607-.6468 0-.8284-.67154-1.5-1.5-1.5-.23174 0-.45094.05235-.6468.14609zm-6.37122-3.06472c.22019.16664.26361.48023.09697.70043-.39019.51562-.70101 1.09415-.9146 1.71749.83076 2.4246 3.1302 4.1667 5.83525 4.1667.39567 0 .78227-.0372 1.15647-.1082.27126-.0514.53293.1268.5844.3981.05146.2713-.1268.5329-.39814.5844-.43526.0825-.8842.1257-1.34273.1257-3.20973 0-5.92542-2.1098-6.838493-5.0169-.030633-.09754-.030633-.20214 0-.29967.248773-.79207.631163-1.52453 1.120443-2.17106.16664-.2202.48023-.26363.70043-.09699z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}
